import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";

import { Company, Staff, StaffShadow, StaffShadowSchedule } from 'app/_models';

@Component({
  selector: 'app-shadow-settings',
  templateUrl: './shadow-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShadowSettingsComponent implements OnInit, OnChanges {
  @Input() companies: Company[];
  @Input() staffs: Staff[];
  @Input() defaultShadowStaffs: StaffShadow[];
  @Input() shadowSchedules: StaffShadowSchedule[];

  newStaffShadow: StaffShadow;
  newShadowSchedule: StaffShadowSchedule;
  staffById: { [id: string]: Staff } = {};

  ngOnInit(): void {
    this.newStaffShadow = new StaffShadow();
    this.newShadowSchedule = new StaffShadowSchedule();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.staffs) {
      const byId: { [id: string]: Staff } = {};
      (this.staffs || []).forEach((staff) => {
        if (staff && staff.id) {
          byId[staff.id] = staff;
        }
      });
      this.staffById = byId;
    }
  }

  matchStaff = (term: string, staff: Staff): boolean => {
    const query = (term || '').trim().toLowerCase();
    if (!query) {
      return true;
    }
    const name = `${staff?.first_name || ''} ${staff?.last_name || ''}`.toLowerCase();
    return name.includes(query);
  };

  onAddStaffShadow() {
    if (this.newStaffShadow.shadow_id) {
      this.defaultShadowStaffs.push(this.newStaffShadow);
      this.newStaffShadow = new StaffShadow();
    }
  }

  onDeleteStaffShadow(i) {
    this.defaultShadowStaffs.splice(i, 1);
  }

  onAddShadowSchedule() {
    if (this.newShadowSchedule.start_at && this.newShadowSchedule.end_at) {
      this.shadowSchedules.push(this.newShadowSchedule);
      this.newShadowSchedule = new StaffShadowSchedule();
    }
  }

  onDeleteShadowSchedule(i) {
    this.shadowSchedules.splice(i, 1);
  }
}